import {completionsCreate} from "./chat/completions-create";
import {completionsCreateWithUi} from "./chat/completions-create-with-ui";
import {websocketPromise} from "./websocket-promise";
import {init} from "./init";
import { addUserMessage } from "./chat/add-user-message";

const gigakit = {
    init: init,
    self: {
        ai: {
            completions: completionsCreate
        }
    },
    shell: {
        ai: {
            add_user_message: addUserMessage,
            completions: completionsCreateWithUi
        }
    },
    marco: () => websocketPromise<string>('marco'),
    chat: {
        completions: {
            create: completionsCreate,
            // create_with_ui: completionsCreateWithUi
        }
    }
}

export default gigakit;